import Vue from "vue";
import envMethods from "@/environment";

const EnvAware = Vue.extend({ methods: { ...envMethods } });

export default EnvAware;
